/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Ios_Open_SafariInputs */



/**
* | output |
* | --- |
* | "Notifications on iPhone and iPad work only in Safari. Open this page in Safari, then tap Share and “Add to Home Screen.”" |
*
* @param {Notifications_Ios_Open_SafariInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const notifications_ios_open_safari = /** @type {((inputs?: Notifications_Ios_Open_SafariInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Ios_Open_SafariInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les notifications sur iPhone et iPad ne fonctionnent que dans Safari. Ouvrez cette page dans Safari, puis appuyez sur Partager et « Ajouter à l’écran d’accueil ».")
	if (locale === "es") return /** @type {LocalizedString} */ ("Las notificaciones en iPhone y iPad sólo funcionan en Safari. Abra esta página en Safari, pulse Compartir y luego «Añadir a pantalla de inicio».")
	if (locale === "pt") return /** @type {LocalizedString} */ ("As notificações no iPhone e iPad funcionam apenas no Safari. Abra esta página no Safari, toque em Compartilhar e depois em \"Adicionar à Tela Inicial\".")
	if (locale === "it") return /** @type {LocalizedString} */ ("Le notifiche su iPhone e iPad funzionano soltanto in Safari. Aprite questa pagina in Safari, toccate Condividi e poi «Aggiungi alla schermata Home».")
	return /** @type {LocalizedString} */ ("Notifications on iPhone and iPad work only in Safari. Open this page in Safari, then tap Share and “Add to Home Screen.”")
});